/*
 *
 * TtlCountdown
 *
 * @version 1.0.0
 * @author Magarelli_Fabrizio
 * @since 01-Oct-2024
 */

import React from 'react'
import { defineMessages } from 'react-intl'
import PortalMessage from 'Hoc/PortalMessage'

const formattedMessage = {
  description: (
    <PortalMessage
      id='t.app.project.popup.ttl.description'
      defaultMessage={`Your session is about to expire. For security reasons, your session will be automatically closed after 5 minutes of inactivity. Click "Stay Connected" to continue your activity.`}
    />
  )
}

export const ariaLabels = defineMessages({
  descriptionAriaLabel: {
    id: 't.app.accessibility.popup.ttl.description.ariaLabel',
    defaultMessage: `The description is: Your session is about to expire. For security reasons, your session will be automatically closed after 5 minutes of inactivity. Click "Stay Connected" to continue your activity.`
  },
  countdownAriaLabel: {
    id: 't.app.accessibility.popup.ttl.countdown.ariaLabel',
    defaultMessage: 'Time remaining before the session expires:'
  }
})

export default formattedMessage
